import {ReactNode, useCallback, useEffect, useMemo, useRef} from "react";

import {IUserPhoneVerificationContextValue, UserPhoneVerificationContext} from "@pg-mono/user";

import {trackAmplitudePhoneVerified} from "../../user/tracking/track_amplitude_phone_verified";
import {
    getSmsLoginError,
    ISmsLoginCredentials,
    ISmsLoginSendResult,
    isSmsLoginAccountMismatchError,
    usePostSmsLoginInitMutation,
    usePostSmsLoginMutation
} from "../api/sms_login";

interface IProps {
    children: ReactNode;
    credentials: ISmsLoginCredentials;
    initialSendResult?: ISmsLoginSendResult | null;
    onInitRejected: (error: {message: string; status: number}) => void;
}

export const PromotionSmsLoginProvider = (props: IProps) => {
    const {children, credentials, initialSendResult = null, onInitRejected} = props;
    const [postSmsLoginInit] = usePostSmsLoginInitMutation();
    const [postSmsLogin] = usePostSmsLoginMutation();
    const initialSendResultRef = useRef<ISmsLoginSendResult | null>(initialSendResult);
    const lastInitialSendResultPropRef = useRef<ISmsLoginSendResult | null>(initialSendResult);

    useEffect(() => {
        if (initialSendResult === lastInitialSendResultPropRef.current) {
            return;
        }

        initialSendResultRef.current = initialSendResult;
        lastInitialSendResultPropRef.current = initialSendResult;
    }, [initialSendResult]);

    const sendPhoneVerificationCode = useCallback(async () => {
        if (initialSendResultRef.current) {
            const result = initialSendResultRef.current;
            initialSendResultRef.current = null;

            if (result.error && isSmsLoginAccountMismatchError(result.error)) {
                onInitRejected(result.error);
            }

            return result;
        }

        const response = await postSmsLoginInit(credentials);

        if (!response.error) {
            return {};
        }

        const error = getSmsLoginError(response.error, "Nie udało się wysłać kodu SMS.");
        if (isSmsLoginAccountMismatchError(error)) {
            onInitRejected(error);
        }

        return {error};
    }, [credentials, onInitRejected, postSmsLoginInit]);

    const verifyPhone = useCallback(
        async (code: string) => {
            const response = await postSmsLogin({...credentials, code});

            if (!response.error) {
                trackAmplitudePhoneVerified(true);
                return {};
            }

            trackAmplitudePhoneVerified(false);

            return {error: getSmsLoginError(response.error, "Nie udało się zweryfikować kodu SMS.")};
        },
        [credentials, postSmsLogin]
    );

    const contextValue = useMemo<IUserPhoneVerificationContextValue>(
        () => ({
            getUserProfile: async () => null,
            sendPhoneVerificationCode,
            verifyPhone
        }),
        [sendPhoneVerificationCode, verifyPhone]
    );

    return <UserPhoneVerificationContext.Provider value={contextValue}>{children}</UserPhoneVerificationContext.Provider>;
};
import {ReactNode, useCallback, useEffect, useMemo, useRef} from "react";

import {IUserPhoneVerificationContextValue, UserPhoneVerificationContext} from "@pg-mono/user";

import {trackAmplitudePhoneVerified} from "../../user/tracking/track_amplitude_phone_verified";
import {
    getSmsLoginError,
    ISmsLoginCredentials,
    ISmsLoginSendResult,
    isSmsLoginAccountMismatchError,
    usePostSmsLoginInitMutation,
    usePostSmsLoginMutation
} from "../api/sms_login";

interface IProps {
    children: ReactNode;
    credentials: ISmsLoginCredentials;
    initialSendResult?: ISmsLoginSendResult | null;
    onInitRejected: (error: {message: string; status: number}) => void;
}

export const PromotionSmsLoginProvider = (props: IProps) => {
    const {children, credentials, initialSendResult = null, onInitRejected} = props;
    const [postSmsLoginInit] = usePostSmsLoginInitMutation();
    const [postSmsLogin] = usePostSmsLoginMutation();
    const initialSendResultRef = useRef<ISmsLoginSendResult | null>(initialSendResult);
    const lastInitialSendResultPropRef = useRef<ISmsLoginSendResult | null>(initialSendResult);

    useEffect(() => {
        if (initialSendResult === lastInitialSendResultPropRef.current) {
            return;
        }

        initialSendResultRef.current = initialSendResult;
        lastInitialSendResultPropRef.current = initialSendResult;
    }, [initialSendResult]);

    const sendPhoneVerificationCode = useCallback(async () => {
        if (initialSendResultRef.current) {
            const result = initialSendResultRef.current;
            initialSendResultRef.current = null;

            if (result.error && isSmsLoginAccountMismatchError(result.error)) {
                onInitRejected(result.error);
            }

            return result;
        }

        const response = await postSmsLoginInit(credentials);

        if (!response.error) {
            return {};
        }

        const error = getSmsLoginError(response.error, "Nie udało się wysłać kodu SMS.");
        if (isSmsLoginAccountMismatchError(error)) {
            onInitRejected(error);
        }

        return {error};
    }, [credentials, onInitRejected, postSmsLoginInit]);

    const verifyPhone = useCallback(
        async (code: string) => {
            const response = await postSmsLogin({...credentials, code});

            if (!response.error) {
                trackAmplitudePhoneVerified(true);
                return {};
            }

            trackAmplitudePhoneVerified(false);

            return {error: getSmsLoginError(response.error, "Nie udało się zweryfikować kodu SMS.")};
        },
        [credentials, postSmsLogin]
    );

    const contextValue = useMemo<IUserPhoneVerificationContextValue>(
        () => ({
            getUserProfile: async () => null,
            sendPhoneVerificationCode,
            verifyPhone
        }),
        [sendPhoneVerificationCode, verifyPhone]
    );

    return <UserPhoneVerificationContext.Provider value={contextValue}>{children}</UserPhoneVerificationContext.Provider>;
};
